import React from 'react';
import {Box, CircularProgress, Typography} from '@mui/material';

/**
 * Loading state component
 */
export const LoadingState = () => (
    <Box sx={{display: 'flex', justifyContent: 'center', py: 4}}>
        <CircularProgress/>
    </Box>
);

/**
 * Error state component
 */
export const ErrorState = ({error}) => (
    <Typography color="error">
        Error loading preview: {error.message || 'Unknown error'}
    </Typography>
);

/**
 * No version selected state component
 */
export const NoVersionState = ({latestVersion}) => (
    <Typography color="text.secondary">
        {latestVersion
            ? 'Redirecting to latest version...'
            : 'No versions available for this report.'}
    </Typography>
);

/**
 * No content available state component
 */
export const NoContentState = ({version}) => (
    <Typography color="text.secondary">
        No content available for version {version}.
    </Typography>
);

